import deepMerge from 'deepmerge';

export { deepMerge };
